import type { useHistory } from 'react-router-dom';
import { IconResponse } from '@applied/proto/web_services/candidate_experience/proto/web_offer_pb';
import type { JsonValue } from '@protobuf-ts/runtime';
import type { MessageType } from '@protobuf-ts/runtime';
import type { ResponseData } from 'api/http_requests';
import { getData, makeAuthenticatedRequest } from 'api/http_requests';

export enum WebOfferIcon {
  EMAIL = 'EMAIL',
  LINKEDIN = 'LINKEDIN',
  HEALTH_INSURANCE = 'HEALTH_INSURANCE',
  COMMUTER = 'COMMUTER',
  FITNESS_LEARNING = 'FITNESS_LEARNING',
  HOUSING = 'HOUSING',
  LANGUAGE = 'LANGUAGE',
  LUNCH_DINNER = 'LUNCH_DINNER',
  PARENTAL_LEAVE = 'PARENTAL_LEAVE',
  PENSION = 'PENSION',
  PTO = 'PTO',
  CONFIDENTIAL = 'CONFIDENTIAL',
  // Semanitcally a bit weird to have this here, but it is the easiest thing to do.
  CONFETTI_ANIMATION = 'CONFETTI_ANIMATION',
  HEART = 'HEART',
}

export const ICON_TO_OBJECT_NAME: Readonly<Record<WebOfferIcon, string>> = Object.freeze({
  [WebOfferIcon.EMAIL]: 'email',
  [WebOfferIcon.LINKEDIN]: 'linkedin',
  [WebOfferIcon.HEALTH_INSURANCE]: 'health-insurance',
  [WebOfferIcon.COMMUTER]: 'commuter-benefits',
  [WebOfferIcon.FITNESS_LEARNING]: 'fitness-learning',
  [WebOfferIcon.HOUSING]: 'housing',
  [WebOfferIcon.LANGUAGE]: 'language',
  [WebOfferIcon.LUNCH_DINNER]: 'lunch-dinner',
  [WebOfferIcon.PARENTAL_LEAVE]: 'parental-leave',
  [WebOfferIcon.PENSION]: 'pension',
  [WebOfferIcon.PTO]: 'pto',
  [WebOfferIcon.CONFIDENTIAL]: 'confidential',
  // .gif is necessary, otherwise it plays multiple times (doesn't respect loop 1 metadata).
  [WebOfferIcon.CONFETTI_ANIMATION]: 'confetti.gif',
  [WebOfferIcon.HEART]: 'heart',
});

const iconResponseType = IconResponse as MessageType<IconResponse>;

export async function getIcon(
  icon: WebOfferIcon,
  history: ReturnType<typeof useHistory>,
): Promise<IconResponse | null> {
  const requestIcon = (): Promise<ResponseData<JsonValue>> =>
    getData(`/api/icons/${ICON_TO_OBJECT_NAME[icon]}`);
  const response = await makeAuthenticatedRequest(requestIcon, history);
  if (!response || response.jsonPayload === null) {
    return null;
  }
  return iconResponseType.fromJson(response.jsonPayload);
}
